import IDream from "motw_core/Entity/IDream";

export function GetShortenedDreamName(dream: IDream) {
	const maxLength = 10;
	if (dream.name.length > maxLength) {
		return dream.name.substring(0, maxLength) + "...";
	}
	return dream.name;
}
